<template>

  <div class="d-flex flex-column gap-3">
    <b-row class="d-flex justify-content-center">
      <b-col class="d-flex justify-content-center">
        <b-button v-for="(platform, i) in platforms" :key="i" variant="link-primary" class="mr-3 p-0 px-2">
          <a :href="platform.url" target="_blank" rel="noopener noreferrer" class="d-flex align-items-center">
            <Icon :name="platform.icon" :size="30" class="ml-1" />
          </a>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Icon from "@/components/Icon.vue";

export default {
  name: "share-buttons",
  components: { Icon },
  data () {
    return {
      platforms: [
        {
          name: "Twitter",
          icon: "twitter",
          url: `https://twitter.com/intent/tweet?text=${this.title}&url=${this.url}`
        },
        {
          name: "Facebook",
          icon: "facebook",
          url: `https://www.facebook.com/sharer/sharer.php?u=${this.url}`
        },
        {
          name: "LinkedIn",
          icon: "linkedin",
          url: `https://www.linkedin.com/sharing/share-offsite/?url=${this.url}`
        },
        {
          name: "Reddit",
          icon: "reddit",
          url: `https://www.reddit.com/submit?url=${this.url}&title=${this.title}`
        },
        {
          name: "WhatsApp",
          icon: "whatsapp",
          url: `https://wa.me/?text=${this.title} ${this.url}`
        }
      ]
    };
  },
  props: {
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: false,
      default: ""
    },
    url: {
      type: String,
      required: true
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/styles/scss/includes/mixins";

$title-margin-top: 76px;
$title-height: 100px;

</style>
<style scoped>

@keyframes float-up {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(-20px);
    opacity: 0;
  }
}

</style>
